import React from 'react';
import styled from '@emotion/styled';
import { BlankLink } from '@contently/toolkit';
import EditingAvatar from './EditingAvatar';
import { FETCH_STATE, HELP_DESK_URL } from './';

const Container = styled.div`
`;

const Heading = styled.span`
  font-weight: 500;
  text-transform: uppercase;
`;

const ListWrapper = styled.div`
`;

export default function UserList({fetchState, users}) {
  // Don't render anything if nobody's currently editing
  if (!users.length) return null;

  if (fetchState === FETCH_STATE.ERROR) {
    return (
      <p>
        There was an error determing current editors.
      </p>
    );
  }

  return (
    <Container>
      <Heading>Currently Editing | </Heading>
      <span>Trouble collaborating? </span>
      <BlankLink
        title="Trouble collaborating? Click here to check user roles."
        href={HELP_DESK_URL}
      >
        Check User Roles
      </BlankLink>
      <ListWrapper fetchState={fetchState}>
        {
          users.length
          ?
            users.map((user, i) => EditingAvatar({...user, key: i, order: i}))
          :
            (
              <p>
                (Nobody is currently editing this story.)
              </p>
            )
        }
      </ListWrapper>
    </Container>
  );
}



// WEBPACK FOOTER //
// ./app/javascript/client/components/CurrentlyEditingUsers/UserList.jsx